'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchMon084Param = exports.fetchIsEligibleForMon084 = exports.mon084CommunicationMethodsConfig = exports.getWhatsAppLink = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _noAuthApiClient = require('hub-http/clients/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

var _laboratoryLib = require('laboratory-lib');

var _whatsapp = require('bender-url!../img/whatsapp.png');

var _whatsapp2 = _interopRequireDefault(_whatsapp);

var _communicationMethodTypes = require('ui-addon-upgrades/_core/communicationMethods/communicationMethodTypes');

var _communicationMethodTypes2 = _interopRequireDefault(_communicationMethodTypes);

var _tracker = require('ui-addon-upgrades/_core/common/eventTracking/tracker');

var tracker = _interopRequireWildcard(_tracker);

var _communicationMethodsConfig = require('./communicationMethodsConfig');

var _communicationMethodsConfig2 = _interopRequireDefault(_communicationMethodsConfig);

var _apiClient = require('hub-http/clients/apiClient');

var _apiClient2 = _interopRequireDefault(_apiClient);

var _mon084CountryCodes = require('./mon084CountryCodes');

var _getLang = require('I18n/utils/getLang');

var _getLang2 = _interopRequireDefault(_getLang);

var _getUserInfo = require('../common/api/getUserInfo');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userEmail = null;
var WHATS_APP_LINK_BASE = 'http://wa.me/14404827768?text=Hi%2C%20I%27d%20like%20to%20talk%20to%20sales.%20My%20email%20address%20is%20';

var getWhatsAppLink = exports.getWhatsAppLink = function getWhatsAppLink() {
  return '' + WHATS_APP_LINK_BASE + userEmail;
};

var mon084CommunicationMethodsConfig = exports.mon084CommunicationMethodsConfig = _communicationMethodsConfig2.default.concat({
  communicationKey: _communicationMethodTypes2.default.WHATSAPP,
  image: _whatsapp2.default,
  useIllustration: false,
  SelectedMethodComponent: null,
  onClick: function onClick(propsToPass) {
    var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    var upgradeData = propsToPass.upgradeData;

    tracker.track('communicationMethodsInteraction', _extends({
      action: 'clicked chat on whatsapp'
    }, upgradeData));

    window.open(getWhatsAppLink(), '_blank');

    onClose();
  }
});

var fetchIsEligibleForMon084 = exports.fetchIsEligibleForMon084 = function fetchIsEligibleForMon084() {
  var lang = (0, _getLang2.default)();
  var userInfoPromise = (0, _getUserInfo.getUserInfo)();

  var isEnglishLang = lang === 'en';
  var countryPromise = _apiClient2.default.get('self-service/v2/country');

  return _q2.default.Promise.all([countryPromise, userInfoPromise]).then(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        countryInfo = _ref2[0],
        userInfo = _ref2[1];

    var country = countryInfo.country;

    userEmail = userInfo && userInfo.user.email;
    if (userEmail && country && isEnglishLang && (_mon084CountryCodes.APAC_COUNTRY_NAMES.includes(country.toLowerCase()) || _mon084CountryCodes.EMEA_COUNTRY_NAMES.includes(country.toLowerCase()))) {
      return true;
    }
    return false;
  }).catch(function (error) {
    if (window.Raven) {
      window.Raven.captureMessage('Mon084 eligibility fetch failed', {
        extra: {
          message: error.message
        }
      });
    }
    return false;
  });
};

var fetchMon084Param = exports.fetchMon084Param = function fetchMon084Param() {
  var GROUP_PARAMETER_OPTIONS = ['control', 'variant'];
  var mon084Key = 'revenue-retention-mon084';
  var treatmentRequest = (0, _laboratoryLib.createTreatmentRequest)(mon084Key);

  return _noAuthApiClient2.default.get(treatmentRequest.url, {
    data: treatmentRequest.body
  }).then(function (treatment) {
    return treatment.parameters;
  }).catch(function (error) {
    if (window.Raven) {
      window.Raven.captureMessage('Failed to fetch MON084 experiment treatment', {
        extra: { error: error }
      });
    }

    return 'control';
  }).then(function (parameters) {
    return (0, _laboratoryLib.getParameter)(parameters, 'group', GROUP_PARAMETER_OPTIONS).value;
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/communicationMethods/mon084Utils.js
// module id = 572
// module chunks = 3 4 5